import { ColumnInput } from '@core/const'
import { ColumnResponse } from '@core/query'
import { Dispatch, PropsWithChildren, SetStateAction, createContext, useContext, useMemo, useState } from 'react'
import { UseFormReturn, useForm } from 'react-hook-form'

const defaultFormValues: ColumnInput = {
  longSideSpan: 0,
  shortSideSpan: 0,
  usage: 'RESIDENTIAL',
  slabThickness: 0,
  stories: 0,
  concreteStrength: 0,
  criterionSize: 0,
}

interface ColumnContext {
  form: UseFormReturn<ColumnInput>
  result: ColumnResponse | null
  setResult: Dispatch<SetStateAction<ColumnResponse | null>>
}

const context = createContext<ColumnContext | undefined>(undefined)

const useDefaultContextValues = () => {
  const form = useForm<ColumnInput>({
    defaultValues: defaultFormValues,
  })

  const [result, setResult] = useState<ColumnResponse | null>(null)

  return useMemo(() => ({
    form,
    result,
    setResult,
  }), [form, result])
}

export function ColumnProvider ({ children }: PropsWithChildren) {
  const { Provider } = context
  const defaultContextValues = useDefaultContextValues()

  return (
    <Provider value={defaultContextValues}>
      {children}
    </Provider>
  )
}

export const useColumn = () => {
  const contextValues = useContext(context)
  const defaultContextValues = useDefaultContextValues()

  return contextValues ?? defaultContextValues
}
